import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("pv_cart") || "[]");
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("pv_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      if (existing) {
        return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        dosage: product.dosage,
        price: product.price,
        accent: product.accent,
        image_url: product.image_url,
        quantity: qty,
      }];
    });
  };

  const remove = (product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  };

  const setQty = (product_id, qty) => {
    if (qty <= 0) return remove(product_id);
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity: qty } : i));
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
